import { render } from "./SignUpCompleted.vue?vue&type=template&id=2dc94833&scoped=true"
import script from "./SignUpCompleted.vue?vue&type=script&lang=js"
export * from "./SignUpCompleted.vue?vue&type=script&lang=js"

import "./SignUpCompleted.vue?vue&type=style&index=0&id=2dc94833&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc94833"]])

export default __exports__